import {
  PriorityModel,
  QueueRelationModel,
  StatusModel,
  TagModel,
  TaskFileModel,
  UserModel,
  WeeekTaskModel,
} from "@/components/task-forms/models";
import { TaskParentModel } from "./TaskParentModel";
import UserTaskItem from "@/pages/monitorings/models/UserTaskItemModel";

/**
 * * Модель задачи
 */
export class TaskModel {
  /**ID задачи */
  Id!: number;
  /**Задача weeek */
  WeeekTask?: WeeekTaskModel
  /**Родительская задача */
  Parent?: TaskParentModel;
  /**Название задачи */
  Name!: string;
  /**ID проекта */
  ProjectId!: number;
  /**ID задачи */
  QueueTaskId!: string;
  /**ID папки */
  FolderId!: string;
  /**ID неймспейса */
  NamespaceId?: string;
  /**Статус */
  StatusId!: number;
  /**Тип задачи */
  TypeId!: string;
  /**Приортите */
  PriorityId!: number;
  /**Уровень сложности */
  DifficultyId!: string;
  /**Описание */
  Description!: string;
  /**Владелец */
  OwnerId!: number;
  /**Исполнители */
  PerformerIds: Array<number> = [];
  /**Наблюдатели */
  ObserverIds: Array<number> = [];
  /**Оценка исполнителей */
  Estimated!: number;
  /**Дата дедлайна */
  DeadlineDate?: Date;
  /**Дата создания */
  DateCreate!: Date;
  /**Дата обновления */
  DateUpdate?: Date;
  /**Список тегов */
  Tags: Array<number> = [];
  /**Подзадачи */
  SubtaskIds: Array<number> = [];
  /**Список пользователей */
  Performers?: UserModel[];
  /**Модель статуса */
  Status?: StatusModel;
  /**Модель приоритета */
  Priority?: PriorityModel;
  /**Наблюдатели */
  Observers?: UserModel[] = [];
  /**Теги */
  TagsObjects?: TagModel[] = [];
  /**Создатель задачи */
  Owner?: UserModel | UserTaskItem;
  /**Список прикрепленных файлов */
  Files: Array<TaskFileModel> = [];
  /**Список очередей задачи */
  QueueToTaskRelationList: QueueRelationModel[] = [];
  /**Количество подзадач */
  SubtaskCount: number = 0;

  constructor(obj?: Partial<TaskModel>) {
    Object.assign(this, obj);
  }
}
